import { createAppWrap } from '../../create_app_wrap';
import commonMixin from '../../mixins/_common';
import flashMessageMixin from '../../mixins/_flash_messages';
import modalBillInfoEditor from '../../components/_modal_bill_info_editor';
import modalCancellation from '../../components/_modal_cancellation';

const STATUS = {
    TRIAL: 1,
    EXPIRED_TRIAL: 2,
    CONTINUATION_RECEPTION: 3,
    CONTINUATION: 4,
    CANCELLATION_RECEPTION: 5,
    CANCELLATION: 6
};

const CHURN_REASON = {
    DESIGNLESS: '好みのデザインがなかった、出来上がったページの質が低い',
    UNSATISFIED: 'カスタマイズ性が低く感じた、必要な機能がなかった',
    DIFFICULT: '難しくて使いこなせないと感じた',
    HOLD: '一旦解約して必要な時にまた使いたい',
    ETC: 'その他',
};

const view = '[data-view="contract"]';
const init = () => {
    createAppWrap({
        el: view,
        data () {
            return {
                change_status: null,
                is_decided: false,
                billing: null,
                token: null,
                // 選択された解約理由
                churn_reason: '',
                // 解約理由「その他」の入力テキスト
                churn_reason_text: ''
            };
        },
        /**
         * コンポーネント
         */
        components: {
            modalBillInfoEditor,
            modalCancellation
        },
        /**
         * ミックスインオブジェクト
         */
        mixins: [
            commonMixin,
            flashMessageMixin
        ],
        created: function() {
            const data = document.querySelector('[data-roll="billing"]');
            if (data) {
                this.billing = JSON.parse(data.innerHTML);
            }
        },
        /**
         * 算出プロパティ
         */
        computed: {
            // 現状のステータス
            status () {
                if (typeof this.config.user_contract === 'undefined') {
                    return null;
                }
                return this.config.user_contract.status;
            },
            // トライアル中か否か
            isStatusTrial () {
                if (this.status === STATUS.TRIAL || this.status === STATUS.EXPIRED_TRIAL) {
                    return true;
                }
                return false;
            },
            // 未返答トライアル終了か否か
            isStatusExpiredTrial () {
                return (this.status === STATUS.EXPIRED_TRIAL);
            },
            // 現状ステータスが継続か否か
            isStatusContinuation () {
                if (this.status === STATUS.CONTINUATION_RECEPTION || this.status === STATUS.CONTINUATION) {
                    return true;
                }
                return false;
            },
            // 申請ステータスが継続か否か
            isChangeStatusContinuation () {
                if (this.change_status === STATUS.CONTINUATION_RECEPTION || this.change_status === STATUS.CONTINUATION) {
                    return true;
                }
                return false;
            },
            // 解約理由
            churnReasonSelect: function () {
                return CHURN_REASON;
            }
        },
        /**
         * 各種メソッド
         */
        methods: {
            // 継続確認モーダルを開く
            confirmContinuation () {
                this.setChangeStatus(STATUS.CONTINUATION_RECEPTION, STATUS.CONTINUATION);
                this.$refs.modalBillInfoEditor.open();
            },
            // 解約確認モーダルを開く
            confirmCancellation () {
                this.setChangeStatus(STATUS.CANCELLATION_RECEPTION, STATUS.CANCELLATION);
                this.$refs.modalCancellation.open();
            },
            // 変更ステータスをセット
            setChangeStatus (trial, trialFinished) {
                if (this.status === STATUS.TRIAL) {
                    this.change_status = trial;
                } else {
                    this.change_status = trialFinished;
                }
            },
            // すべてのモーダルを閉じる
            closeModal () {
                const modals = [
                    this.$refs.modalBillInfoEditor,
                    this.$refs.modalCancellation
                ];
                for (const modal of modals) {
                    if (modal.isOpen()) {
                        modal.close();
                    }
                }
            },
            // 回答送信
            async decide () {
                let message = this.exception_error_message;
                try {
                    this.$_loading();
                    const response = await axios.post('/contract/decide', {
                        _method: 'PUT',
                        status: this.change_status,
                        churn_reason: this.churn_reason,
                        churn_reason_text: this.churn_reason_text
                    });
                    if (response.data.status === 'OK') {
                        // 回答送信完了画面へ切り替える
                        this.is_decided = true;
                        // エラーメッセージを空にする
                        message = '';
                    }
                } catch (e) {
                    message = this.getCatchMessage(e);
                }
                this.closeModal();
                this.$_unloading();
                if (message) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: message,
                    });
                }
            },
            async submitBilling (postParams) {
                try {
                    const response = await axios.post('/billing', {
                        _method: 'POST',
                        staff_name: postParams.staff_name,
                        email: postParams.email,
                        token: postParams.token
                    });
                    if (response.data.status === 'OK') {
                        this.closeModal();
                        this.appendFlashMessage({
                            level: 'alert-success',
                            message: 'ご請求先を保存しました',
                        });
                        this.decide(); // ステータス更新
                    }
                } catch (e) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: this.getCatchMessage(e),
                    });
                }

            },
        }
    });
};

if (document.querySelector(view)) {
    init();
}
